import { Coupon } from '../models/cart'
import { getFormattedPrice } from './formattedPrice'

export function getDiscountTypeText (coupon: Coupon) {
  if (coupon) {
    const type = coupon.campaignType
    switch (type) {
      case 20:
        return `Rabatt: ${coupon?.discount}%`
      case 10:
        return `Rabatt: ${coupon?.discount} kr`
      case 30:
        return 'Gratis leverans'
      default:
        return ''
    }
  }
}

export function getDiscountAmountText (coupon: Coupon) {
  if (coupon && coupon?.totalDiscount) {
    const total = coupon.totalDiscount
    switch (true) {
      case total === 0:
        return ''
      case total > 0:
        return `-${getFormattedPrice(coupon.totalDiscount)}`
      default:
        return ''
    }
  }
}

export function getDiscountErrorMessage (reasonCode: string) {
  const CAMPAIGNMINIMUMPURCHASEAMOUNTRULE = 'CampaignMinimumPurchaseAmountRule'
  const CAMPAIGNDATERULE = 'CampaignDateRule'
  const CAMPAIGNUSERULE = 'CampaignUseRule'
  const DISCOUNT_EXCEEDS_TOTAL = 'DISCOUNT_EXCEEDS_TOTAL'

  switch (reasonCode) {
    case CAMPAIGNMINIMUMPURCHASEAMOUNTRULE:
      return 'Varukorgens värde är för lågt. Angiven kod kan ej appliceras.'
    case CAMPAIGNDATERULE:
      return 'Angiven kod är ej längre giltig.'
    case CAMPAIGNUSERULE:
      return 'Angiven kod är förbrukad.'
    case DISCOUNT_EXCEEDS_TOTAL:
      return 'Rabatten överstiger varukorgens värde.'
    default:
      return 'Angiven kod är ej giltig, vänligen försök igen.'
  }

}